const events = {
  PAGE_LOAD: 'Page Load',
  PAGE_VIEW: 'Page View',
  QUERY_SHOP: 'Query Entered',
  SELECT_SHOP: 'Start Booking',
  CHOOSE_PROFESSIONAL_CLICKED: 'Choose professional clicked',
  CHOOSE_SERVICE_CLICKED: 'Choose Service clicked',
  SELECT_BARBER: 'Professional Selected',
  SELECT_ANY_BARBER: 'Any Professional Selected',
  SELECT_SERVICE: 'Service Selected',
  SELECT_DATE: 'Selected date',
  SELECT_TIME: 'Selected time',
  REVIEW_AND_BOOK: 'Date and Time Selected',
  REVIEW_AND_PAY: 'Review and Pay',
  WAITING_LIST: 'Waiting List clicked',
  WAITING_LIST_WITH_APPLE_PAY: 'Waiting List with Apple Pay clicked',
  FILL_PERSONAL_INFO: 'Filled personal info',
  START_PAYMENT: 'Start Payment',
  CREDIT_CARD_NUMBER_ENTERED: 'CC Number Entered',
  CREDIT_CARD_EXP_DATE_ENTERED: 'CC Expiry Date Entered',
  CREDIT_CARD_CVC_ENTERED: 'CC Security Code Entered',
  CREDIT_CARD_ZIP_CODE_ENTERED: 'CC Zip Code Entered',
  TIP_OPTION_ACTIVE: 'Tip option is active',
  TIP_SELECTED: 'Tup Selected',
  FILL_CARD_INFO: 'Filled Card Info',
  ABANDON_PAYMENT: 'Abandoned Payment',
  PAYMENT_ERROR: 'Payment Failure',
  RESERVE_AND_PAY: 'Reserve and Pay Confirmed',
  RESERVE_AND_PROVIDE_CARD: 'Reserve and Provide Card clicked',
  RESERVE: 'Reserve Confirmed',
  BOOKING_COMPLETE: 'Booking Complete',
  SHOW_STRIPE_MODAL: 'Showed Stripe Modal',
  SHOW_SQUIRE_MODAL: 'Showed Squire Modal',
  ONLY_PAY_ACTIVE: 'Only Pay is Active',
  RESERVE_AND_PROVIDE_CARD_ACTIVE: 'Reserve and Provide card is Active',
  RESERVE_WITHOUT_PAY_ACTIVE: 'Reserve without Pay is Active',
  ONLY_RESERVE_ACTIVE: 'Only Reserve is Active',
  PROMO_ACTIVE: 'Promo is Active',
};

export default events;



// WEBPACK FOOTER //
// ./src/app/applicationServices/analytics/events/index.js